import { API_BASE } from '../../constants';
import { makeHttpGet } from '../';
import { ComparisonAssetHeaderUseCase } from '../../usecases';
import {
  IComparisonAssetHeader,
  IGetAssetMemory,
  ISetAssetColorRepo,
  ISetAssetMemory,
} from '../../interfaces';

export const makeComparisonAssetHeader = (
  assetColorRepo: ISetAssetColorRepo,
  assetMemoryRepo: IGetAssetMemory<IComparisonAssetHeader> &
    ISetAssetMemory<IComparisonAssetHeader>
) => {
  const url = `${API_BASE}/general/header`;
  const httpGet = makeHttpGet<IComparisonAssetHeader>();

  return new ComparisonAssetHeaderUseCase(
    url,
    httpGet,
    assetColorRepo,
    assetMemoryRepo
  );
};
